import React from "react";
import styled from "@emotion/styled";
import { Typography } from "../Typography";

type Option = {
  value: string;
  label: string;
};

const Title = styled(Typography)`
  border-bottom: solid 1px ${(props) => props.theme.colors.mushroomDark};
  padding: 0.8rem 1.6rem;
`;

const List = styled.ul`
  padding: 0px;
  width: 100%;
  overflow: auto;
  margin: 4px 0 0 0;
  list-style: none;
  border: 1px solid ${(props) => props.theme.colors.darkGrey};
  background-color: ${(props) => props.theme.colors.snowdrop};
  outline: none;

  &:focus {
    outline: none;
  }
`;

const ListItem = styled.button<{ isSelected?: boolean; isFocused?: boolean }>`
  color: ${(props) =>
    props.isSelected ? props.theme.colors.forest : props.theme.colors.charcoal};
  padding: 0.8rem 1.6rem;
  outline: none;
  cursor: pointer;
  width: 100%;
  text-align: initial;
  background-color: white;
  border: none;

  background-color: ${(props) =>
    props.isSelected && "rgba(32, 191, 133, 0.27)"};

  &:focus {
    background-color: "rgba(0, 0, 0, 0.062)";
  }

  &:hover {
    background-color: ${(props) =>
      props.isSelected ? null : "rgba(0, 0, 0, 0.062)"};
  }
`;

export type OptionListProps = {
  options: Option[];
  title: string;
  isSelected?: boolean;
  isFocused?: boolean;
  selectedOption?: any;
  onSelectOption: (option: any) => void;
};

/** TODO: component needs to be tabbable/focusable */

export const OptionList = ({
  options,
  title,
  selectedOption,
  onSelectOption,
}: OptionListProps) => {
  return (
    <div role="tablist">
      <List>
        <Title use="body2" as="h3">
          {title}
        </Title>

        {options.map((option) => {
          return (
            <ListItem
              key={option.label}
              onClick={() => {
                if (selectedOption !== option.value) {
                  onSelectOption(option.value);
                }
              }}
              isSelected={option.value === selectedOption}
            >
              <Typography use="body1" as="p">
                {option.label}
              </Typography>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};
